import PropTypes from "prop-types";

const Label = ({ children, className = "", onClick = () => {}, isActive = false }) => {
  return (
    <label
      className={`${className} ${
        isActive && "!border-sportsYellow"
      } bg-[#F8F8F8] border-solid border-[#F8F8F8] border-2 p-2 rounded-full w-fit flex gap-2 text-[10px] justify-center items-center font-medium`}
      onClick={onClick}
    >
      {children}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.any,
};

export default Label;
